import { useQuery } from 'react-query';
import { instance } from '@/api';
import { CommentT } from '@/api/community/comments';

export interface AddPostT {
  user_id: any;
  type: string;
  title: string;
  contents: string;
  id?: number;
}

export interface PostT {
  id: number;
  user_id: number;
  type: string;
  title: string;
  contents: string;
  hit: number;
  like: number;
  is_open: number;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  likes_count: string;
  user: {
    id: number;
    name: string;
  };
}

// GET
export const fetchPosts = (params: { type?: 'notice' | 'free' | 'event' }) => {
  return instance.get(`/community`, {
    params: {
      ...params,
    },
  });
};

// POST
export const fetchAddPosts = async (posts: AddPostT) => {
  const { data } = await instance.post('/community', {
    ...posts,
  });
  return data;
};

// 상세
export const fetchDetailPosts = async ({ id }: { id: number }) => {
  const { data } = await instance.get<{ post: PostT; comments: CommentT[] }>(
    `/community/${id}`
  );
  return data;
};

export function useDetailPosts({
  id,
  initialData,
}: {
  id: number;
  initialData?: any;
}) {
  return useQuery(['detail', id], () => fetchDetailPosts({ id: Number(id) }), {
    initialData,
  });
}

// 삭제
export const deletePostById = async (id: number) => {
  const { data } = await instance.delete(`/community/${id}`);
  return data;
};
// 수정 posts/{post}/edit
export const updatePostById = async ({ posts }: { posts: AddPostT }) => {
  return instance.post(`/community/${posts.id}/update`, {
    ...posts,
  });
};
